module.exports = __webpack_public_path__ + "static/media/fatoraty-footer.e4a370b3.svg";